import PropTypes from 'prop-types';

import styles from './RPCritic.module.scss';
import { URLS } from '@/constants/urls';

export const RPCritic = ({ parkerTastingNote }) => {
  return (
    <div className={styles.container}>
      <img src={URLS.LOGO_RP_COLOR} alt="robert-parker" width={224} loading="lazy" />
      <span>&quot;<span dangerouslySetInnerHTML={{ __html: parkerTastingNote }} />&quot;</span>
    </div>
  );
};

RPCritic.propTypes = {
  parkerTastingNote: PropTypes.string
};

export default RPCritic;
